//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'

import '@react/App.css'
import { BrowserRouter } from 'react-router-dom'
import OperatorRouting from './OperatorRouting'

import { LicenseInfo } from '@mui/x-license-pro'

import { ErrorBoundary } from '@react/components/ErrorBoundary'

LicenseInfo.setLicenseKey(
  '4aa820c74354bf0194df6f7dfa013a7fTz0xMTE4ODYsRT0xNzc3MDc1MTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
)

function OperatorApp(): React.ReactElement {
  document.title = 'OpenTrade Admin'

  return (
    <div className="App">
      <title>OpenTrade Admin </title>

      <BrowserRouter>
        <ErrorBoundary>
          <OperatorRouting />
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  )
}

export default OperatorApp
